import React from 'react';
import { useSelector } from 'react-redux';

import AppSlider from './AppSlider';
import FacetsLoader from '../Loader/FacetsLoader';

const ClientsRequestsFilter = ({ onChange, reset }) => {
  const requestsRangeMinMax = useSelector(
    ({ search }) => search.clientFacetData.requestsRangeMinMax,
  );
  const isGetFasets = useSelector(({ search }) => search.isGetFasets);
  const [min, max] = requestsRangeMinMax;

  const handleChange = (values) => {
    onChange(values);
  };

  const renderSlider = () => {
    return isGetFasets ? (
      <FacetsLoader />
    ) : (
      <AppSlider
        step={1}
        min={min}
        max={max}
        values={requestsRangeMinMax}
        onChange={handleChange}
        reset={reset}
      />
    );
  };

  return (
    <div className="content-inner-data-aside-left">
      <div className="content-card-row-title">Количество обращений</div>
      <div className="content-card-row">{renderSlider()}</div>
    </div>
  );
};

export default ClientsRequestsFilter;
